import React, {  useContext, useMemo } from 'react'
import './style.css'
import {
  PAYPAL_THEME,
} from '@paypalcorp/pp-react'
import { CleverContext } from '../cleverContext'
import { isApplicationAutomationEligible } from 'ppbl/utils/clever-utils'
import { toCommaSeparatedNumber } from '../../__utils__'

type SliderProps = {
  min?: number
  max?: number
  stepper?: number
  value?: number
  label?: string
  prefix?: string
  suffix?: string
  onChange?: (value: number) => void
}

const InputSlider: React.FC<SliderProps> = ({
  min,
  max,
  stepper,
  value,
  label,
  prefix,
  suffix,
  onChange,
}) => {
  const {
    loanAmount,
    application,
    offerValues,
  } = useContext(CleverContext)

  const { sysColorPrimaryMain, sysColorErrorMain } = PAYPAL_THEME

  const percentage = max === min ? 0 : ((value - min) / (max - min)) * 100

  const isAutomationEligible = isApplicationAutomationEligible(
    application?.tags,
  )

  const isEnabled = useMemo(
      () =>
        offerValues?.isQualified &&
        Number(loanAmount) <= Number(offerValues?.maxAmount),
      [offerValues],
    )

  const getSliderStyle = (): React.CSSProperties => {
    const percentages =
      max === min
        ? 0
        : ((Number(value) - Number(min)) / (Number(max) - Number(min))) * 100
    const fillColor =
      isEnabled
      ? sysColorPrimaryMain
      : sysColorErrorMain
    const defaultTrackColor = '#ddd'

    return {
      // Use bracket notation for custom CSS variables
      ['--value-percent' as any]: `${percentages}%`,
      ['--fill-color' as any]: fillColor,
      ['--default-track-color' as any]: defaultTrackColor,
    }
  }

  return (
    <div className="sliderWrapper">
      <div className="sliderContainer">
        <div
          className="slider-value-label"
          style={{
            ['--label-position' as any]: percentage,
            background: sysColorPrimaryMain,
            borderTopColor: sysColorPrimaryMain,
          }}
        >
          <div className="slider-value-label-content">
            {prefix ?? ''}
            {toCommaSeparatedNumber(value)}
            {suffix ?? ''}
          </div>
        </div>
        <input
          type="range"
          min={min}
          max={max}
          step={stepper}
          value={value}
          onChange={(e) => {
            onChange(Number(e.target.value))
          }}
          className="sliderInput"
          style={getSliderStyle()}
        />
      </div>
    </div>
  )
}

export default InputSlider
